<template>
    <BreadCrumb PageTitle="Modifier un emploi du temps" />
    <EditEmploi />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditEmploi from "@/components/EmploiDuTemps/EditEmploi.vue";
  
    export default defineComponent({
      name: "EditEmploiPage",
      components: {
        BreadCrumb,
        EditEmploi,
      },
    });
  </script>